import {useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import {useAuth} from '../services/authContext';
import {useFarm} from '../services/farmContext';
/** Resolve property/account before opening content; never bypass route guards. */
export default function PushNavigation(){
 const {user}=useAuth(),{setActiveFarmId}=useFarm(),navigate=useNavigate();
 useEffect(()=>{
  if(!user||!('serviceWorker' in navigator))return;
  let live=true;
  const open=async(data:{url:string;account?:string;farm?:string})=>{
   if(!live)return;
   const url=new URL(data.url,location.origin);
   url.searchParams.delete('pushAccount');url.searchParams.delete('pushFarm');
   const account=Array.from(new Uint8Array(await crypto.subtle.digest('SHA-256',new TextEncoder().encode(user.email.trim().toLowerCase())))).map(v=>v.toString(16).padStart(2,'0')).join('');
   if(!live)return;
   if(url.origin!==location.origin||data.account!==account||user.status!=='Active'||(!user.roles?.includes('Admin')&&data.farm&&!user.farm_ids?.includes(data.farm))){navigate('/profile',{replace:true});return;}
   if(data.farm)await setActiveFarmId(data.farm);if(live)navigate(url.pathname+url.search+url.hash);
  };
  const message=(event:MessageEvent)=>{if(event.data?.type==='OPEN_PUSH')void open(event.data);};
  navigator.serviceWorker.addEventListener('message',message);
  const url=new URL(location.href);
  if(url.searchParams.has('pushAccount'))void open({url:url.href,account:url.searchParams.get('pushAccount')||'',farm:url.searchParams.get('pushFarm')||''});
  return()=>{live=false;navigator.serviceWorker.removeEventListener('message',message);};
 },[user?.email,user?.status,JSON.stringify(user?.farm_ids),JSON.stringify(user?.roles),setActiveFarmId,navigate]);
 return null;
}
